import { useMemo, useState } from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Tabs, type TabItem } from '@/components/common/Tabs';
import { usePermission } from '@/permissions/usePermission';
import { SymbolsTab } from './tabs/SymbolsTab';
import { TdiInstrumentsTab } from './tabs/TdiInstrumentsTab';
import { AssetClassesTab } from './tabs/AssetClassesTab';
import { ExecutionVenuesTab } from './tabs/ExecutionVenuesTab';
import { GroupCategoriesTab } from './tabs/GroupCategoriesTab';
import { LoginInformationTab } from './tabs/LoginInformationTab';
import { PortfoliosTab } from './tabs/PortfoliosTab';

const P = 'User.Onboarding';

export function OnboardingPage() {
  const can = usePermission();

  const tabs = useMemo<TabItem[]>(() => {
    const t: TabItem[] = [];
    if (can(`${P}.Symbols.View`)) t.push({ key: 'symbols', title: 'Symbols' });
    if (can(`${P}.TDIInstruments.View`)) t.push({ key: 'tdi-instruments', title: 'TDI Instruments' });
    if (can(`${P}.AssetClass.View`)) t.push({ key: 'asset-classes', title: 'Asset Classes' });
    if (can(`${P}.ExecutionVenues.View`)) t.push({ key: 'execution-venues', title: 'Execution Venues' });
    if (can(`${P}.GroupCategories.View`)) t.push({ key: 'group-categories', title: 'Group Categories' });
    if (can(`${P}.LoginInformation.View`)) t.push({ key: 'login-information', title: 'Login Information' });
    if (can(`${P}.Portfolios.View`)) t.push({ key: 'portfolios', title: 'Portfolios' });
    return t;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [active, setActive] = useState('');
  const activeKey = active || tabs[0]?.key || '';

  return (
    <div className="onboarding-page">
      <PageHeader title="Onboarding" breadcrumb={['Home', 'Onboarding']} />

      <div className="card custom-card mb-0">
        <div className="card-header p-0">
          <Tabs tabs={tabs} active={activeKey} onChange={setActive} variant="underline" />
        </div>
        <div className="card-body">
          {activeKey === 'symbols' && <SymbolsTab />}
          {activeKey === 'tdi-instruments' && <TdiInstrumentsTab />}
          {activeKey === 'asset-classes' && <AssetClassesTab />}
          {activeKey === 'execution-venues' && <ExecutionVenuesTab />}
          {activeKey === 'group-categories' && <GroupCategoriesTab />}
          {activeKey === 'login-information' && <LoginInformationTab />}
          {activeKey === 'portfolios' && <PortfoliosTab />}
          {tabs.length === 0 && (
            <p className="text-muted mb-0">You don't have access to any Onboarding tabs.</p>
          )}
        </div>
      </div>
    </div>
  );
}
